/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle guide visibility" |
*
* @param {Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_toggle_visibility_aria_label = /** @type {((inputs?: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer la visibilite du guide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leitfaden-Sichtbarkeit umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la visibilità della guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить видимость руководства")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar la visibilidad de la guía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换指南可见性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドの表示を切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड की दृश्यता को टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar visibilidade do guia")
	return /** @type {LocalizedString} */ ("Toggle guide visibility")
});